/**
 * Created by rathompson on 4/13/22
 * File: AppImage
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import { NoLogo } from '../../../common/assets/images'

import type { CSSProperties } from 'react'
import type { AppManifest } from '@sparky/framework'

type AppImageProps = {
  app_id: string
  apps: {
    [key: string]: AppManifest
  }
  alt: string
  style: CSSProperties
}
const AppImage = (props: AppImageProps) => {
  const { apps, app_id, alt, ...rest } = props
  const src = useMemo(() => {
    const appsInfo = apps[app_id]
    if (appsInfo?.extension_to) {
      return apps[appsInfo.extension_to].normalized_logo_url || NoLogo
    }
    return appsInfo?.normalized_logo_url || NoLogo
    //return get(apps, `${appsInfo}.normalized_logo_url`, NoLogo)
  }, [app_id, apps])

  return <img src={src} alt={alt || 'img'}{...rest}/>
}

export default AppImage

